import { render, staticRenderFns } from "./PosServers.vue?vue&type=template&id=3f3856b2"
import script from "./PosServers.vue?vue&type=script&lang=js"
export * from "./PosServers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports